<script setup lang="ts">
import { createTextVNode, defineComponent, onMounted } from 'vue';
import { useDialog, useLoadingBar, useMessage, useNotification } from 'naive-ui';
import { useAuthStore } from '@/store/modules/auth';
import { useOrgStore } from '@/store/modules/org';

defineOptions({
  name: 'AppProvider'
});

const authStore = useAuthStore();
const orgStore = useOrgStore();

const ContextHolder = defineComponent({
  name: 'ContextHolder',
  setup() {
    function register() {
      window.$loadingBar = useLoadingBar();
      window.$dialog = useDialog();
      window.$message = useMessage();
      window.$notification = useNotification();
    }

    register();

    return () => createTextVNode();
  }
});

// 初始化组织信息
onMounted(async () => {
  if (authStore.isLogin) {
    await orgStore.initOrgInfo();
  }
});
</script>

<template>
  <NLoadingBarProvider>
    <NDialogProvider>
      <NNotificationProvider>
        <NMessageProvider :duration="5000">
          <NModalProvider>
            <ContextHolder />
            <slot></slot>
          </NModalProvider>
        </NMessageProvider>
      </NNotificationProvider>
    </NDialogProvider>
  </NLoadingBarProvider>
</template>

<style scoped></style>
